<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.show_offer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #404b3e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <!-- <base-image-upload-input col="12" identifier="image" :placeholder="$t('PLACEHOLDERS.image')"
             /> -->
          <!-- End:: Image Upload Input -->

          <div class="d-flex justify-center gap-3 flex-wrap">
            <div v-if="data.image.path">
              <!-- Display image -->
              <div class="preview-container text-center my-3">
                <h6 style="color: #404b3e">
                  {{ $t("PLACEHOLDERS.advertisement_ar") }}
                </h6>
                <video
                  v-if="
                    [
                      'mp4',
                      'mov',
                      'avi',
                      'wmv',
                      'flv',
                      'mkv',
                      'webm',
                      'm4v',
                    ].some((ext) => data.image.path.endsWith(ext))
                  "
                  :src="data.image.path"
                  controls
                  autoplay
                  loop
                  muted
                ></video>
                <img v-else :src="data.image.path" alt="Advertisement Image" />
              </div>
            </div>
          </div>

          <!-- <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            disabled
            :preSelectedImage="data.image.path"
          /> -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            disabled
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            disabled
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            disabled
          />

          <!-- Start:: Used In Display -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advertisement_location')"
            :value="getUsedInDisplayName(data.used_in)"
            disabled
          />
          <!-- End:: Used In Display -->

          <!-- Start:: Related to Ad Display -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.related_to_ad')"
              v-model="data.is_related_to_ad"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Related to Ad Display -->

          <!-- Start:: Selected Ad Display -->
          <base-input
            v-if="data.is_related_to_ad"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.select_ad')"
            :value="data.selected_ad?.name || data.selected_ad?.nameAr || data.selected_ad?.nameEn"
            disabled
          />
          <!-- End:: Selected Ad Display -->

          <!-- End:: Name Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";

export default {
  name: "CreateAds",
  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      file: null,
      fileType: "",
      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          type: null,
        },
        image2: {
          path: null,
          type: null,
        },
        nameAr: null,
        nameEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        media: null,
        media_type: null,
        used_in: null,
        is_related_to_ad: false,
        selected_ad: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {},

  methods: {
    getUsedInDisplayName(value) {
      const options = {
        landlord_app: this.$t
          ? this.$t("OPTIONS.landlord_app")
          : "تطبيق المؤجر",
        tenant_app: this.$t ? this.$t("OPTIONS.tenant_app") : "تطبيق المستأجر",
        all_apps: this.$t ? this.$t("OPTIONS.all_apps") : "جميع التطبيقات",
      };
      return options[value] || value;
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `banners/${this.$route.params.id}`,
        });
        this.data.image.path = res.data.data.banner.image;
        // this.data.image2.path = res.data.data.banner.media_en;
        this.data.nameAr = res.data.data.banner.title_ar;
        this.data.nameEn = res.data.data.banner.title_en;
        this.data.publish_start_date = res.data.data.banner.start_date;
        this.data.publish_end_date = res.data.data.banner.end_date;
        this.data.used_in = res.data.data.banner.used_in;
        this.data.active = res.data.data.banner.is_active;
        // Set related ad data if available
        if (res.data.data.banner.type === "ad" && res.data.data.banner.ad) {
          this.data.is_related_to_ad = true;
          this.data.selected_ad = {
            id: res.data.data.banner.ad?.id,
            name: res.data.data.banner.ad?.name,
          };
        }
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
